module.exports = __webpack_public_path__ + "img/image06.70072f36.png";